import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL ?? 'http://localhost:4000/api',
});

api.interceptors.request.use(config => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// A 401 means the token is missing, expired, or invalid. Clear the stale session and
// signal the app to fall back to the login page, rather than leaving a dead token in
// place — which otherwise surfaces as an uncaught error on every protected request.
//
// 403 is a genuine authorization failure for an otherwise-valid token (e.g. wrong role)
// and is deliberately left alone. The /auth/ endpoints handle their own 401s (e.g. a
// wrong password on login), so they are exempt to avoid disturbing the login form.
api.interceptors.response.use(
  response => response,
  error => {
    const status = error.response?.status;
    const url: string = error.config?.url ?? '';
    if (status === 401 && !url.includes('/auth/')) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      window.dispatchEvent(new Event('auth:unauthorized'));
    }
    return Promise.reject(error);
  }
);

export default api;
